// Local AI-assisted preview only. Merchant artwork approval required.
window.SHRVY_STUDIO={
  "rebellion-t-shirt": [
    {
      "src": "assets/studio-v5/rebellion-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/rebellion-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/rebellion-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/rebellion-original-models-front.png",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/rebellion-t-shirt-model-back-corrected.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "untamable-t-shirt": [
    {
      "src": "assets/studio-v5/untamable-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/untamable-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/untamable-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/untamable-t-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/untamable-t-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "slice-t-shirt": [
    {
      "src": "assets/studio-v5/slice-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/slice-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/slice-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/slice-t-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/slice-t-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "thrive-t-shirt": [
    {
      "src": "assets/studio-v5/thrive-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/thrive-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/thrive-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/thrive-t-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/thrive-t-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "all-or-nothing-t-shirt": [
    {
      "src": "assets/studio-v6/all-or-nothing-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/all-or-nothing-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/all-or-nothing-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/all-or-nothing-t-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/all-or-nothing-t-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "resilient-t-shirt": [
    {
      "src": "assets/studio-v5/resilient-t-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/resilient-t-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/resilient-t-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/resilient-t-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/resilient-t-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "patches-shirt": [
    {
      "src": "assets/studio-v6/patches-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/patches-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/patches-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/patches-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/patches-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "grungre-shirt": [
    {
      "src": "assets/studio-v5/grungre-shirt-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/grungre-shirt-back.jpg",
      "view": "back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v5/grungre-shirt-folded.jpg",
      "view": "folded",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/grungre-shirt-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/grungre-shirt-model-back.jpg",
      "view": "model-back",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "beige-cap": [
    {
      "src": "assets/studio-v6/beige-cap-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/beige-cap-detail.jpg",
      "view": "detail",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/beige-cap-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "story-cap": [
    {
      "src": "assets/studio-v6/story-cap-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/story-cap-detail.jpg",
      "view": "detail",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/story-cap-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "deep-red-cap": [
    {
      "src": "assets/studio-v6/deep-red-cap-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/deep-red-cap-detail.jpg",
      "view": "detail",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/deep-red-cap-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ],
  "forest-shadow-cap": [
    {
      "src": "assets/studio-v6/forest-shadow-cap-front.jpg",
      "view": "front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/forest-shadow-cap-detail.jpg",
      "view": "detail",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    },
    {
      "src": "assets/studio-v6/forest-shadow-cap-model-front.jpg",
      "view": "model-front",
      "kind": "AI studio reconstruction",
      "approval": "pending merchant artwork review"
    }
  ]
};
